import React from 'react';
import { IFeed } from '@lib/instagram/client';
import { getResizedImageUrl } from '@lib/image';
import styles from './FollowOnInstagram.module.scss';

const PROFILE_URL = 'https://www.instagram.com/thehavenly/';
const TILE_RESIZE_WIDTH = 600;

const FALLBACK_IMAGES = [
  'https://static.havenly.com/home/instagram-fallback/1.jpg',
  'https://static.havenly.com/home/instagram-fallback/2.jpg',
  'https://static.havenly.com/home/instagram-fallback/3.jpg',
  'https://static.havenly.com/home/instagram-fallback/4.jpg',
];

interface IFollowOnInstagramProps {
  feeds?: IFeed[];
}

interface ITile {
  key: string;
  href: string;
  imageUrl: string;
  alt: string;
}

function tilesFromFeeds(feeds: IFeed[]): ITile[] {
  return feeds.slice(0, 4).map((feed) => ({
    key: feed.id,
    href: feed.permalink || PROFILE_URL,
    imageUrl: feed.media_type === 'VIDEO' ? feed.thumbnail_url : feed.media_url,
    alt: feed.caption || 'Havenly Instagram post',
  }));
}

function fallbackTiles(): ITile[] {
  return FALLBACK_IMAGES.map((imageUrl, i) => ({
    key: `fallback-${i}`,
    href: PROFILE_URL,
    imageUrl: getResizedImageUrl({
      url: imageUrl,
      width: TILE_RESIZE_WIDTH,
      height: TILE_RESIZE_WIDTH,
      quality: 80,
    }),
    alt: 'Havenly Instagram',
  }));
}

export default function FollowOnInstagram({ feeds = [] }: IFollowOnInstagramProps) {
  const tiles = feeds.length > 0 ? tilesFromFeeds(feeds) : fallbackTiles();

  return (
    <section className={styles.Section} data-test="follow-on-instagram">
      <h2 className={styles.Title}>Follow us on instagram</h2>
      <div className={styles.Grid}>
        {tiles.map((tile) => (
          <a
            key={tile.key}
            href={tile.href}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.Tile}
          >
            <img
              src={tile.imageUrl}
              alt={tile.alt}
              className={styles.TileImage}
              loading="lazy"
            />
          </a>
        ))}
      </div>
    </section>
  );
}
